import React from 'react';
import { FullPageLoader, ModalContainer } from '@tassomutuo-backoffice/ui';
import { Alert, Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { getLeadNotes } from '../../../services/api/lead/lead';
import { useDateFormat } from '../../../hooks';
import NoteCard from './NoteCard';
import { selectUser, useUserStore } from '../../../store/user';
import { getHsEmailInLocalStorage } from '../../../services/localStorage/localStorage';

interface IProps {
  open: boolean;
  handleClose: () => void;
  leadId?: string;
}

const ModalLeadNotesList = ({ open, handleClose, leadId }: IProps) => {
  const user = useUserStore(selectUser);

  const { formatDate } = useDateFormat();
  const {
    isPending,
    data: notes,
    error,
  } = useQuery({
    queryKey: ['leadNotes', leadId],
    queryFn: () => getLeadNotes(leadId!),
    enabled: !!leadId,
  });

  const filteredNotes = (() => {
    if (!notes) return undefined;
    if (user?.role === 'admin') return notes;

    const hsEmailInLocalStorage = getHsEmailInLocalStorage();
    const allowedEmails = hsEmailInLocalStorage
      ? [user?.email, hsEmailInLocalStorage]
      : [user?.email];

    return notes.filter((note) => allowedEmails.includes(note.owner?.email));
  })();

  return (
    <ModalContainer
      open={open}
      handleClose={handleClose}
      title="Lista note"
      containerSx={{ maxWidth: '500px' }}
      mtHeader={0}
    >
      <>
        <FullPageLoader show={isPending} />
        {!isPending && error && (
          <Alert severity="info">{error.message || 'An Error occurred'}</Alert>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '100%',
            overflow: 'scroll',
            width: '100%',
          }}
        >
          {filteredNotes &&
            filteredNotes.length > 0 &&
            filteredNotes.map((n) => (
              <NoteCard
                key={n.id}
                body={n.properties.hs_body_preview}
                owner={n.owner}
                createdDate={formatDate(
                  n.properties.hs_createdate,
                  'dd/MM/yyyy HH:mm'
                )}
              />
            ))}

          {!isPending && !error && filteredNotes?.length === 0 && (
            <Alert severity="info" sx={{ m: 4 }}>
              Non ci sono note da visualizzare per questa lead
            </Alert>
          )}
        </Box>
      </>
    </ModalContainer>
  );
};

export default ModalLeadNotesList;
